module.exports = __webpack_public_path__ + "img/sv.d5123e34.png";